// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — select.styled.classic.js, новая — select.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './select.styled.classic';
import * as cp from './select.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
